var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconListDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#666B6D;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn-close",
    transform: "translate(-325 -229)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_14",
    x: 325,
    y: 229,
    className: "st0",
    width: 44,
    height: 44
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_62",
    transform: "translate(346.026 188.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_22",
    className: "st1",
    d: "M-3,66.5l8-8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23",
    className: "st1",
    d: "M5,66.5l-8-8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListDelete);
export default __webpack_public_path__ + "static/media/icon_list_delete.20557ee0eec2cb26e4f8de37f1e43f62.svg";
export { ForwardRef as ReactComponent };